<div class="welcome-container">
  <div class="welcome-content">
    <h1 class="welcome-title">
      {{ "welcome.title" | translate : { brand: brand } }}
    </h1>
    <p class="welcome-subtitle">{{ "welcome.subtitle" | translate }}</p>

    <div class="options-container">
      <button class="user-option new-user-option" (click)="navigateToOnboarding()">
        <div class="option-icon">
          <mat-icon>person</mat-icon>
        </div>
        <div class="option-content">
          <div class="option-title">
            {{ "welcome.newUser.title" | translate }}
          </div>
          <div class="option-description">
            {{ "welcome.newUser.description" | translate }}
          </div>
        </div>
        <div class="option-arrow">
          <mat-icon class="rtl-icon">chevron_right</mat-icon>
        </div>
      </button>

      <button class="user-option existing-user-option" (click)="navigateToLogin()">
        <div class="option-icon">
          <mat-icon class="rtl-icon">arrow_forward</mat-icon>
        </div>
        <div class="option-content">
          <div class="option-title">
            {{ "welcome.existingUser.title" | translate }}
          </div>
          <div class="option-description">
            {{ "welcome.existingUser.description" | translate }}
          </div>
        </div>
        <div class="option-arrow">
          <mat-icon class="rtl-icon">chevron_right</mat-icon>
        </div>
      </button>
    </div>
  </div>
</div>
